var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartRef",staticStyle:{"width":"60%","height":"220px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }